module.exports = __webpack_public_path__ + "img/subway.3b69ccb4.png";